import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { calculateTotals } from "../../redux/slices/cartSlice";
import { getAllCart } from "../../services/cartService";
import { order } from "../../services/OrderService";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import emailjs from "emailjs-com";
import { addCustomer, editCustomer, getstatesByGuid, updatecustomer, userService } from "../../services/AuthenticationService";
import AddressCard from "./AddressCard";
import { CustomerClass } from "../../utils/json/Customer";
import { CustomerReceiptType } from "../../utils/json/CustomerReceiptType";
import { LedgerClass } from "../../utils/json/Ledger";
import Branch from "../../utils/json/Branch";
import { useForm } from "react-hook-form";

const Checkout = () => {
  emailjs.init("79qjoEW9pqMcI2NAf"); // Or PUBLIC_KEY from EmailJS


   const userId = useSelector((state) => state.auth.userId); 
   const [cartItems, setCartItems] = useState([]);
   const [isFormValid, setIsFormValid] = useState(false);
   const dispatch = useDispatch();
   const navigate = useNavigate();
   const [selectedAddressIndex, setSelectedAddressIndex] = useState(null);
const [editingIndex, setEditingIndex] = useState(null);
const [registrationSuccess, setRegistrationSuccess] = useState(false);
const [deliveryAddressStr, setDeliveryAddressStr] = useState("");


  const { register, reset, handleSubmit, watch, setValue, formState: { errors } } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });
 useEffect(() => {
       if (userId) {
        const fetchCart = async () => {
          try {
            const cartItems = await getAllCart(userId);
            setCartItems(Array.isArray(cartItems) ? cartItems : []);
            
          } catch (error) {
            console.error("Failed to load wishlist:", error);
          }
        };
        fetchCart();
      }
    }, []);
    const initialAddressState = {
      name: "",
      country: "",
      address: "",
      landmark: "",
      city: "",
      state: "",
      zip: "",
      email: "",
    };
    const [showAddressForm, setShowAddressForm] = useState(false);
    const [addresses, setAddresses] = useState([]);
    const [newAddress, setNewAddress] = useState(initialAddressState);
    const [formData, setFormData] = useState({
      name: "",
      userName: "",
      mobile: "",
      email: "",
      address1: "",
      address2: "",
      address3: "",
      deliveryAddress: "",
      city: "",
      state: "",
      zip: "",
      country: "",
      phone: "",
     
    });
    console.log("formData",formData)
   useEffect(() => {
         if (userId) {
           userService(userId)
             .then((response) => {
               setFormData(response);
               console.log("Fetched user profile:", response); 
             })
             .catch((error) => console.error("Error fetching profile:", error));
         }
       }, [userId]);
       
 
  const subtotal = cartItems.reduce((sum, item) => sum + item.retailRate * item.quantity, 0);
  const discount = 0.0;
  const total = subtotal - discount;


  // const handleNewAddressChange = (e) => {
  //   const { name, value } = e.target;
  //   setNewAddress((prev) => ({
  //     ...prev,
  //     [name]: value,
  //   }));
  // };
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };
  const handleFormSubmit = async (newData) => {
    const objCustomer = new CustomerClass();
      const objCustRecptTYpe = new CustomerReceiptType();
      const objLedger = new LedgerClass();
      const objBranch = new Branch(); // create branch object
    //const state = new State();
    const address = newData.deliveryAddress;
  
    objCustomer.name = formData.name;
    objCustomer.fullName = "";
  //  objCustomer.mobile = "";
    objCustomer.email = ""; // If email is outside deliveryAddress
    objCustomer.address1 = "" ;
    objCustomer.address2 = "";
    objCustomer.address3 = "";
    objCustomer.discountPercentage = 0;
    objCustomer.city = "";
    objCustomer.pin = "";
   // objCustomer.phone = "";
    objCustomer.fax = "";
    objCustomer.landMark = "";
    objCustomer.gstNo = "";
    objCustomer.UserName = formData.userName;
    objCustomer.Password = formData.password;
    objCustomer.id = formData.id;
    objCustomer.guid = formData.guid;
  //  objCustomer.country = address.country || null;
    console.log("Country value:", address.country);

    
   const formattedAddress = `${address.name}, ${address.phone}, ${address.address}, ${address.landmark} - ${address.zip}, ${address.city}, ${address.state}, ${address.country} , ${address.email}`;
objCustomer.deliveryAddress = formattedAddress;
    objCustomer.creditLimit = 0;
   // objCustomer.guid = null;
    objCustomer.version = 0;
    objCustomer.isDeleted = false;
   // objCustomer.state = address.state;
    objCustomer.updatedUser = null; //`{00000000-0000-0000-0000-000000000000}`;
  
    // (rest of customerReceiptType, ledger, branch stays same)
    objCustomer.customerReceiptType = {
      id: 0,
      guid: "",
      version: 0,
      isDeleted: false,
      createdUser: "",
      createdDate: new Date().toISOString(),
      updatedUser: "",
      updatedDate: new Date().toISOString(),
      name: "",
      Name: ""
    };
  
    // Ledger
    objCustomer.ledger = {
      id: 0,
      guid: "",
      version: 0,
      isDeleted: false,
      createdUser: "",
      createdDate: new Date().toISOString(),
      updatedUser: "",
      updatedDate: new Date().toISOString(),
      name: ""
    };
  
    // Branch
    objCustomer.branch = {
      name: "",
      company: null,
      prefixInvoice: null,
      address1: null,
      address2: null,
      address3: null,
      phone: null,
      email: null,
      cloneBranchId: null,
      id: 0,
      guid: "00000000-0000-0000-0000-000000000000",
      version: 0,
      isDeleted: false,
      createdUser: null,
      createdDate: "0001-01-01T00:00:00",
      updatedUser: null,
      updatedDate: "0001-01-01T00:00:00"
    };
     // State
objCustomer.state = {
  id: 0,
  name: address.state,
  code: "",
  guid:"a3e800ad-256f-4aec-9b7c-c041dc23316e", // "00000000-0000-0000-0000-000000000000",
  version: 0,
  isDeleted: false,
  createdUser: null,
  createdDate: "0001-01-01T00:00:00",
  updatedUser: null,
  updatedDate: "0001-01-01T00:00:00"
};
objCustomer.country = {
  id: 4,
  name: address.country,
  code: "in",
  guid: null, //"00000000-0000-0000-0000-000000000000",
  version: 0,
  isDeleted: false,
  createdUser: null,
  createdDate: "0001-01-01T00:00:00",
  updatedUser: null,
  updatedDate: "0001-01-01T00:00:00"
};

    try {
      const response = await editCustomer(objCustomer);
      console.log("Response from backennnd:", response.data);
      console.log("Returned deliveryAddresssss:", response?.data?.deliveryAddress);
      if (response) {
        toast.success("Registration successful");
      
        // Set the formatted delivery address string
        //const formattedAddress = `${address.name}, ${address.phone}, ${address.address}, ${address.landmark}, ${address.city}, ${address.state}, ${address.country} - ${address.zip}`;
        setDeliveryAddressStr(formattedAddress);
        console.log("Formatted Address:", formattedAddress);
        setRegistrationSuccess(true);
        setShowAddressForm(false);
      } else {
        toast.error("Failed");
      }
    } catch (error) {
      toast.error(error?.response?.data?.Message || "Something went wrong");
      console.error("Error:", error);
    }
    
  };
  
 
  
  const handleEditAddress = (index) => {
    if (index === "registered") {
      // Parse the formatted address string
      const parts = formData.deliveryAddress.split(",").map(p => p.trim());
      const [name, phone, address, landmarkZip, city, state, countryWithEmail] = parts;
      const [landmark, zip] = landmarkZip?.split(" - ") ?? ["", ""];
      const [country, email] = countryWithEmail?.split(" , ") ?? ["", ""];
  
      const parsedAddress = {
        name: name || "",
       // phone: phone || "",
        address: address || "",
        landmark: landmark || "",
        zip: zip || "",
        city: city || "",
        state: state || "",
        country: country || "",
        email: email || "",
      };
  
      setNewAddress(parsedAddress);
      setShowAddressForm(true);
      setEditingIndex("registered");
    } else {
      // Editing from saved address list
      setNewAddress(addresses[index]);
      setShowAddressForm(true);
      setEditingIndex(index);
    }
  };
  
  
  const handleDeleteAddress = (index) => {
    const updated = [...addresses];
    updated.splice(index, 1);
    setAddresses(updated);
    if (selectedAddressIndex === index) setSelectedAddressIndex(null);
  };

const handleSubmitOrder=async () =>{
// const selectedAddress =
//   selectedAddressIndex === "profile" ? formData : addresses[selectedAddressIndex];
const selectedAddress =
  selectedAddressIndex === "profile"
    ? formData
    : selectedAddressIndex === "registered"
    ? newAddress
    : null;
    if (cartItems.length === 0) {
      toast.error("Your cart is empty. Please add products before placing an order.");
      return;
    }

if (!selectedAddress) {
  toast.error("Please select a delivery address");
  return;
}

  const orderData = {
    id: 0,
    guid: "", 
    version: 0,
    isDeleted: false,
    createdUser: userId,
    createdDate: new Date().toISOString(),
    updatedUser: userId,
    updatedDate: new Date().toISOString(),
    orderStatus: "Pending",
    totalAmount: total,
    orderItemsList: cartItems.map(item => ({
      id: item.id,
      guid: item.guid,
      version: 0,
      isDeleted: false,
      createdUser: userId,
      createdDate: new Date().toISOString(),
      updatedUser: userId,
      updatedDate: new Date().toISOString(),
      prodGuId: item.prodGuId,
      orderItemStatus: "Pending",
      quantity: item.quantity,
      unitPrice: item.retailRate,
      discount: 0,
      subTotal: item.retailRate * item.quantity,
    }))
  }
  console.log(orderData)
  if(formData){
    //button place order active
    
    try {
      const result = await order(orderData);
    
      const emailPayload = {
        customer_name: formData.name,
        customer_email: formData.email,
        order_id: result || "N/A",
        order_items: cartItems.map(item => `${item.shortName} x ${item.quantity}`).join(", "),
        total_amount: total,
        sub_total: subtotal,
        discount: discount,
        formData,
        customer_address: formData.address2,
        customer_zip: formData.zip,
        customer_country: formData.country,
      };
    
      console.log("email payload", emailPayload);
    
      // ✅ Actually send the email
      await sendOrderEmails(emailPayload);
    
      // Optionally navigate after email success
    } catch (error) {
      console.error("Order placement failed:", error);
      toast.error("Failed to place order.");
    }
    
 
  }
}
const sendOrderEmails = async ({ customer_name, customer_email, order_id, order_items, total_amount,sub_total,}) => {
  try {
    // Customer Email
    const customerEmailPromise = emailjs.send(
      'service_rz0vruk',
      'template_xikwb7p',
      {
        customer_name,
        customer_email,
        order_id,
        order_items,
        total_amount,
        sub_total,
        discount,
        formData
      
      }
    );

    // Admin Email
    const adminEmailPromise = emailjs.send(
      'service_rz0vruk',
      'template_exxbvpf',
      {
        admin_email: 'axobisgsuit@gmail.com',
        customer_name,
        customer_email,
        customer_address: formData.address1,
        customer_zip: formData.pin,
        order_id,
        order_items,
        total_amount,
        sub_total,
        discount,
        formData
      }
    );
  
    await Promise.all([customerEmailPromise, adminEmailPromise]);
    console.log("Emails sent successfully.");
    toast.success("Order placed and email sent!");
    
    navigate("/Order-summary", {
      state: {
        order_id, 
        formData,
        cartItems,
        total,
        subtotal,
        discount,
      },
    });
  } catch (error) {
    console.error("Email sending failed:", error);
    toast.error("Order placed, but failed to send emails.");
  }
};
useEffect(() => {
  if (formData?.deliveryAddress) {
    setRegistrationSuccess(true);
  }
}, [formData]);
useEffect(() => {
  if (showAddressForm && newAddress) {
    reset(newAddress); // Set form field values
  }
}, [showAddressForm, newAddress, reset]);

  return (
    <div className="bg-imagea">
      <section className="checkout-section pb-5">
        <div className="container mt-2">
         
          <div className="row mt-2 g-5">
          <div className="col-xl-8 ">
          <div className="col-xl-12 ">
          <h3 className="text-white"> Select a Delivery Address</h3>
              <form onSubmit={handleSubmit} className="billing-form p-0 p-md-0">
                <div className="mb-2 mt-2 text-white">Addresses</div>
                <div className="row align-items-end">
                 
{/* Profile Address */}
<div className="bg-color p-3 mb-3">
  <div className="form-check">
    <input
      type="radio"
      name="selectedAddress"
      value="profile"
      checked={selectedAddressIndex === "profile"}
      onChange={() => setSelectedAddressIndex("profile")}
      className="form-check-input"
    />
    <label className="form-check-label text-white">
      {formData.name}, {formData.address1}, {formData.pin}
      <br />
      Phone: {formData.mobile || "N/A"} | Email: {formData.email}
    </label>
    <button
    className="btn btn-sm btn-outline-light me-2 ml-4"
    onClick={() => navigate("/profile")}
  >
    Edit
  </button>
  </div>
</div>


{/* Registered Delivery Address (after registrationSuccess) */}
{registrationSuccess && (
  <div className="bg-color p-3 mb-3">
    <div className="form-check d-flex justify-content-between align-items-center">
      <div>
        <input
          type="radio"
          name="selectedAddress"
          value="registered"
          checked={selectedAddressIndex === "registered"}
          onChange={() => setSelectedAddressIndex("registered")}
          className="form-check-input me-2"
        />
        <label className="form-check-label text-white">
        {formData.deliveryAddress}
        </label>
      </div>
      <div>
        <button
          type="button"
          className="btn btn-sm btn-outline-light me-2"
          onClick={() => handleEditAddress("registered")}
        >
          Edit
        </button>
        {/* <button
          type="button"
          className="btn btn-sm btn-outline-danger"
          onClick={() => {
            setNewAddress(initialAddressState);
            setDeliveryAddressStr("");
            setRegistrationSuccess(false);
            if (selectedAddressIndex === "registered") {
              setSelectedAddressIndex(null);
            }
          }}
        >
          Delete
        </button> */}
      </div>
    </div>
  </div>
)}

{/* <div className=" bg-color p-3 mb-3">
 <div className="form-check">
    <input
      type="radio"
      name="selectedAddress"
      value="profile"
      checked={selectedAddressIndex === "profile"}
      onChange={() => setSelectedAddressIndex("profile")}
      className="form-check-input"
    />
   <label className="form-check-label text-white">
 
    {formData.deliveryAddress}

    <br />
    Phone: {formData.mobile || "N/A"} | Email: {formData.email}
  </label>
  </div>
    </div>   */}
                </div>
              </form>
            </div>
       
                       <div className="container mt-4">
                       {!registrationSuccess && (
  <button
    type="button"
    className="btn btn-outline-light mt-3"
    onClick={() => setShowAddressForm(true)}
  >
    Add New Address
  </button>
)}


      {showAddressForm && (
        <div className="col-xl-12 bg-color text-white mt-4 rounded p-4 shadow">
          <form onSubmit={handleSubmit(handleFormSubmit)} className="billing-form">
            <h3 className="mb-4">Add a New Delivery Address</h3>
            <div className="row align-items-end">
              <div className="col-md-6">
                <label>Name</label>
                <input type="text" name="name"
                 //value={formData.name} 
                 {...register("deliveryAddress.name", { required: true })}
                 onChange={handleChange}
                  className="form-control bg-dark text-white border-light" />
              </div>
              <div className="col-md-6">
                <label>Phone</label>
                <input type="text" name="phone"
               // value={newAddress.phone} 
                {...register("deliveryAddress.phone", { required: true })}
                onChange={handleChange} className="form-control bg-dark text-white border-light" />
              </div>
              <div className="col-md-12">
                <label>Address</label>
                <input type="text" name="address" 
                //value={newAddress.address}
                {...register("deliveryAddress.address", { required: true })} 
                onChange={handleChange} className="form-control bg-dark text-white border-light" />
              </div>
              <div className="col-md-6">
                <label>Landmark</label>
                <input type="text" name="landmark" 
                //value={newAddress.landmark} 
                {...register("deliveryAddress.landmark", { required: true })}
                onChange={handleChange} className="form-control bg-dark text-white border-light" />
              </div>
              <div className="col-md-6">
                <label>Town / City</label>
                <input type="text" name="city" 
                //value={newAddress.city}
                {...register("deliveryAddress.city", { required: true })} 
                onChange={handleChange} className="form-control bg-dark text-white border-light" />
              </div>
              <div className="col-md-6">
                <label>State</label>
                <input type="text" name="state" 
                //value={newAddress.state}
                {...register("deliveryAddress.state", { required: true })} 
                onChange={handleChange} className="form-control bg-dark text-white border-light" />
              </div>
              <div className="col-md-6">
                <label>Country</label>
                <input type="text" name="country" 
                //value={newAddress.country}
                {...register("deliveryAddress.country", { required: true })} 
                onChange={handleChange} className="form-control bg-dark text-white border-light" />
              </div>
              <div className="col-md-6">
                <label>Postcode / ZIP</label>
                <input type="text" 
                name="zip"
                //value={newAddress.zip}
                {...register("deliveryAddress.zip", { required: true })} 
                onChange={handleChange} className="form-control bg-dark text-white border-light" />
              </div>
              <div className="col-md-6">
                <label>Email Address</label>
                <input type="email" name="email"
                 //value={formData.email}
                  {...register("deliveryAddress.email", { required: true })} 
                 onChange={handleChange} className="form-control bg-dark text-white border-light" />
              </div>
            </div>
            <div className="mt-4">
              <button type="submit" className="btn btn-light text-dark rounded-0 me-2">Add</button>
              <button type="button" className="btn btn-secondary rounded-0" onClick={() => setShowAddressForm(false)}>Cancel</button>
            </div>
          </form>
        </div>
      )}
    </div>
</div>
            <div className="cart-total col-xl-4 text-white text-left pt-0 pr-0 ">
              <div className="p-4 bg-color">
                <h3>Cart Totals</h3>
                <p class="d-flex">
                  <span>Subtotal</span>
                  <span>{subtotal}</span>
                </p>
            
                <p class="d-flex">
                  <span>Discount</span>
                  <span>{discount}</span>
                </p>
                <hr />
                <p class="d-flex total-price">
                  <span>Total</span>
                  <span>{total}</span>
                </p>

              </div>
            
              <div className="p-4 bg-color mt-5 pb-5">
                <h3 className="">Order through Email</h3>
               
               

                {/* <button type="submit" className="btn btn-primary rounded-0" onClick={handleSubmitOrder}
               disabled={isFormValid} >Place Order</button> */}
               <button
  className="btn btn-primary mt-4"
 // disabled={!selectedAddressIndex}
  onClick={handleSubmitOrder}
>
  Place Order
</button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Checkout;
